var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card text-dark m-0" }, [
    _c("div", { staticClass: "card-header", attrs: { id: "headingOne" } }, [
      _c("div", { staticClass: "row" }, [
        _vm.status
          ? _c("div", { staticClass: "col-8" }, [
              _c("div", { staticClass: "custom-control custom-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.status,
                      expression: "status",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { id: _vm.createItemID, type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.status)
                      ? _vm._i(_vm.status, null) > -1
                      : _vm.status,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.status,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.status = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.status = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.status = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: _vm.createItemID },
                  },
                  [
                    _c("del", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.task.name)),
                    ]),
                  ]
                ),
              ]),
            ])
          : _c("div", { staticClass: "col-8" }, [
              _c("div", { staticClass: "custom-control custom-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.status,
                      expression: "status",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { id: _vm.createItemID, type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.status)
                      ? _vm._i(_vm.status, null) > -1
                      : _vm.status,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.status,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.status = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.status = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.status = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: _vm.createItemID },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.task.name) +
                        "\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3" }, [
          _c(
            "div",
            { staticClass: "text-muted text-center font-weight-lighter" },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.task.date) +
                  "\n                "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-1" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-block",
              attrs: { type: "button" },
              on: { click: _vm.onClick },
            },
            [_c("i", { staticClass: "fas fa-chevron-down" })]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "content",
        staticClass: "collapse",
        attrs: { "data-parent": `#${_vm.name}` },
      },
      [
        _c("div", {
          staticClass: "card-body bg-light",
          domProps: { innerHTML: _vm._s(_vm.task.description) },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }